import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const AccountNumber00Table: GenericTableSchemaInterface = {
  id: "account-number-00",
  name: "Account Number 00",
  description: "This table contains data around the account number integration.",
  core: CoreType.STORAGE,
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Facility Name",
      variable: VarKey.LocationName
    },
    c04: {
      name: "Location Number",
      variable: VarKey.LocationLocationNumber
    },
    c05: {
      name: "Start"
    },
    c06: {
      name: "Get Tenant Started"
    },
    c07: {
      name: "Tenant Found"
    },
    c08: {
      name: "Account Number Found"
    },
    c09: {
      name: "SMS Sent"
    },
    c10: {
      name: "SMS Invalid Phone Number"
    },
    c11: {
      name: "Email Sent"
    },
    c12: {
      name: "LLM Used"
    },
    c13: {
      name: "Account Number",
      variable: VarKey.TenantAccountNumber
    }
  }
};
